"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var isPassword = function isPassword(message) {
  return function (_ref) {
    var field = _ref.field;

    if (!field.value) {
      return true;
    } // const isLength = validator.isLength(field.value, {min: 10, max: undefined});


    var isLength = field.value.length >= 10; // set regex for conditions

    var uppercase = /^(?=.*[A-Z])/;
    var lowercase = /^(?=.*[a-z])/;
    var digits = /^(?=.*\d)/;
    var special = /^(?=.*[_\W])/; // test regex against field value

    var isUppercase = uppercase.test(field.value);
    var isLowercase = lowercase.test(field.value);
    var isNumber = digits.test(field.value);
    var isSpecial = special.test(field.value);
    var isValid = isLength && isUppercase && isLowercase && isNumber && isSpecial;
    return [isValid, message || 'Please enter password of at least 10 characters and having lowercase, uppercase, number, special character.'];
  };
};

var _default = isPassword;
exports.default = _default;
//# sourceMappingURL=isPassword.js.map